
import { AssignmentReturned } from '@mui/icons-material';
import ReportProblemOutlinedIcon from '@mui/icons-material/ReportProblemOutlined';

export const relationShipmentsConfig = () => {
    return {
        orderShipments:  {
            title: 'shipments',
            icon: <AssignmentReturned/>,
            isSingleDataGrid: true,
        },
        claims:  {
            title: 'claims',
            icon: <ReportProblemOutlinedIcon/>,
            isSingleDataGrid: true,
        },
    };
};
